import { useApolloClient, useLazyQuery, gql } from '@apollo/client';
import { CommodityWrapper } from '@bechtel/types';
import { forEach } from 'lodash';
import { GET_COMMODITIES_BY_COMMODITY_IDS } from '@bechtel/client-gql';

export function useCommodityCache() {
  const [getCommoditiesByIds] = useLazyQuery<{ commodities: CommodityWrapper[] }, { ids: string[] }>(
    GET_COMMODITIES_BY_COMMODITY_IDS,
    { fetchPolicy: 'network-only' }
  );
  const client = useApolloClient();

  const updateCommoditiesCache = (commodityIds: string[]) => {
    if (!commodityIds || commodityIds.length == 0) return;
    const cachedCommodityIds: string[] = [];

    forEach(commodityIds, (commodityId) => {
      let cachedCommodity = client.readFragment({
        id: 'MaterialCommodity:' + commodityId,
        fragment: gql`
          fragment materialcommodity on MaterialCommodity {
            id
          }
        `,
      });

      if (!cachedCommodity) {
        cachedCommodity = client.readFragment({
          id: 'Weld:' + commodityId,
          fragment: gql`
            fragment weldcommodity on Weld {
              id
            }
          `,
        });
      }
      if (cachedCommodity) cachedCommodityIds.push(commodityId);
    });

    if (cachedCommodityIds.length == 0) return;

    getCommoditiesByIds({
      variables: {
        ids: cachedCommodityIds,
      },
    });
  };

  return { updateCommoditiesCache };
}
